module.exports = __webpack_public_path__ + "media/bootstrap-icons/pin-40a4a452.svg";